import { z } from 'zod';

export const oauthQuerySchema = z.string().min(1).max(16_000);
export const oauthRedirectSchema = z.object({ redirect: z.boolean(), url: z.string().min(1) });
export const authorizationSchema = z.object({
  clientId: z.string(),
  name: z.string(),
  website: z.url().nullable(),
  redirectUri: z.string(),
  scopes: z.array(z.string()),
});
export const connectionSchema = z.object({
  id: z.string(),
  clientId: z.string(),
  name: z.string(),
  website: z.url().nullable(),
  scopes: z.array(z.string()),
  createdAt: z.iso.datetime().meta({ pattern: undefined }),
});
